module.exports = __webpack_public_path__ + "media/images/emoji-by-47665c3a12020252d11f30aca1589166.png";